export default __webpack_public_path__ + "static/product-b-maxipro-49e6da6841064d3c00af0abd4576c4a4.jpg";